export const FETCH_PERSON_SERVICES_LOADING = 'FETCH_PERSON_SERVICES_LOADING';
export const FETCH_PERSON_SERVICES_SUCCESS = 'FETCH_PERSON_SERVICES_SUCCESS';
export const RESET_PERSON_SERVICES = 'RESET_PERSON_SERVICES';
